import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import { useTranslation } from "react-i18next";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.76791 3C7.53771 1.66667 9.46221 1.66667 10.232 3L14.8508 11C15.6206 12.3333 14.6584 14 13.1188 14H3.88116C2.34156 14 1.37931 12.3333 2.14911 11L6.76791 3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50004 4.66675C8.86823 4.66675 9.16671 4.96522 9.16671 5.33341V9.66675C9.16671 10.0349 8.86823 10.3334 8.50004 10.3334C8.13185 10.3334 7.83337 10.0349 7.83337 9.66675V5.33341C7.83337 4.96522 8.13185 4.66675 8.50004 4.66675Z"
        fill="white"
      />
      <path
        d="M9.16671 12.0001C9.16671 12.3683 8.86823 12.6667 8.50004 12.6667C8.13185 12.6667 7.83337 12.3683 7.83337 12.0001C7.83337 11.6319 8.13185 11.3334 8.50004 11.3334C8.86823 11.3334 9.16671 11.6319 9.16671 12.0001Z"
        fill="white"
      />
    </svg>
  ),
  default: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.40192 4.5C10.5566 2.5 13.4434 2.5 14.5981 4.5L21.5263 16.5C22.681 18.5 21.2376 21 18.9282 21H5.0718C2.76239 21 1.31902 18.5 2.47372 16.5L9.40192 4.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7C12.5523 7 13 7.44772 13 8V14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5V8C11 7.44772 11.4477 7 12 7Z"
        fill="white"
      />
      <path
        d="M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z"
        fill="white"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.40192 4.5C10.5566 2.5 13.4434 2.5 14.5981 4.5L21.5263 16.5C22.681 18.5 21.2376 21 18.9282 21H5.0718C2.76239 21 1.31902 18.5 2.47372 16.5L9.40192 4.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7C12.5523 7 13 7.44772 13 8V14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5V8C11 7.44772 11.4477 7 12 7Z"
        fill="white"
      />
      <path
        d="M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z"
        fill="white"
      />
    </svg>
  ),
};

function WarningIcon(props: SvgIconProps) {
  const { t } = useTranslation();
  const fontSize = ["small", "large"].includes(props.fontSize as "small" | "large") ? props.fontSize : "default";
  const item = size[fontSize as "small" | "large" | "default"];

  return (
    <SvgIcon {...props} aria-label={t("global.warning_text")}>
      {item}
    </SvgIcon>
  );
}

export default WarningIcon;
